export const rulesData = [
  {
    id: "income-tax-rule-2026",
    name: "Income Tax Rule, 2026",
    description: "Detailed sections of the Income Tax Rule, 2026 as updated.",
    originalUrl: "https://www.incometaxindia.gov.in/income-tax-rule-2026",
    chapters: []
  },
  {
    id: "income-tax-rule-1962",
    name: "Income Tax Rule, 1962",
    description: "Detailed sections of the Income Tax Rule, 1962 as updated.",
    originalUrl: "https://www.incometaxindia.gov.in/web/guest/income-tax-rules",
    chapters: []
  }
];
